<script setup lang="ts">
withDefaults(defineProps<{
  title?: string | undefined;
  options?: string[] | number[];
  labelLeft?: string | boolean;
  labelRight?: string | boolean;
  invalid?: boolean;
}>(), {
  title: undefined,
  options: () => [1,2,3,4,5],
  labelLeft: undefined,
  labelRight: undefined,
  invalid: false,
});

const model = defineModel<number | string>();
</script>

<template>
  <div class="flex flex-col gap-2">
    <div
      v-if="title"
      v-sanitize-html="title"
      class="text-12 font-bold text-neutral-80"
    />

    <SelectButton
      v-model="model"
      :options="options"
      aria-labelledby="basic"
      :invalid="invalid"
      class="w-full"
      :pt="{
        root: {
          class: 'flex flex-wrap sm:flex-nowrap mobile-styles'
        },
        button: {
          class: 'py-2.5 w-full'
        },
        label: {
          class: 'text-14'
        }
      }"
    />

    <div class="flex items-center text-14 text-neutral-70">
      <div
        v-if="labelLeft"
        class="text-nowrap"
      >
        {{labelLeft}}
      </div>

      <div class="w-full" />

      <div
        v-if="labelRight"
        class="text-nowrap"
      >
        {{labelRight}}
      </div>
    </div>
  </div>
</template>

<style>
@media (max-width: 639px) {
  .mobile-styles .p-button {
    border-right: 1px solid #d1d5db;
    border-top: 0;
  }

  .mobile-styles .p-button:first-of-type {
    border-top:1px solid #d1d5db;
    border-radius: 6px 6px 0 0;
  }

  .mobile-styles .p-button:last-of-type {
    border-radius: 0 0 6px 6px;
  }

  .p-invalid .p-button {
    border-color:red;
  }

  .p-invalid .p-button:first-of-type {
    border-color:red;
  }
}
</style>